/** The login site's check of an email address before any request is sent. The server checks `format: email` as well. */
export class EmailAddressFormat {
    wholeAddressPattern = /^[^\s@,]+@[^\s@,]+\.[^\s@,]+$/u;
    isWellFormed(address) {
        return this.wholeAddressPattern.test(address.trim());
    }
}
//# sourceMappingURL=EmailAddressFormat.js.map